// Assets
import Linkedin from "../../assets/linkedin.svg";
import "./index.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <section className="section-wrapper">
        <h1 className="footer-title">Let’s be Friends</h1>
        <div className="footer-links">
          <a
            target="_blank"
            href="https://www.linkedin.com/in/hayk-ayvazyan-237483229/"
            className="footer-link"
            rel="noreferrer"
          >
            <img src={Linkedin} alt="linkedin" />
          </a>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
